import {
  PSMS_PA_APPROVAL_DENIAL_TREND_REQUEST,
  PSMS_PA_CASE_SUBMISSION_CHANNEL_REQUEST,
  PSMS_PA_CASE_SUBMISSION_REQUEST,
  PSMS_PA_TAT_TREND_REQUEST,
} from '@src/middleware/actions/actionTypes';
import {
  getPSMSPAApprovalDenialTrendFailure,
  getPSMSPAApprovalDenialTrendLoading,
  getPSMSPAApprovalDenialTrendSuccess,
  getPSMSPACaseSubmissionChannelFailure,
  getPSMSPACaseSubmissionChannelLoading,
  getPSMSPACaseSubmissionChannelSuccess,
  getPSMSPACaseSubmissionFailure,
  getPSMSPACaseSubmissionLoading,
  getPSMSPACaseSubmissionSuccess,
  getPSMSPATatTrendFailure,
  getPSMSPATatTrendLoading,
  getPSMSPATatTrendSuccess,
} from '@src/middleware/actions/psms/psmsPAAction';
import {
  getPSMSPAApprovalDenialTrendData,
  getPSMSPACaseSubmissionChannelData,
  getPSMSPACaseSubmissionData,
  getPSMSPATatTrendData,
} from '@src/middleware/services/psms/priorAuth/priorAuth.service';
import { call, put, takeLatest } from 'redux-saga/effects';

export function* fetchPSMSPACaseSubmissionData(action: any) {
  const payload = action?.payload || {};
  yield put(getPSMSPACaseSubmissionLoading(true));
  try {
    const response = yield call(getPSMSPACaseSubmissionData, payload);
    if (response?.Data) {
      yield put(getPSMSPACaseSubmissionSuccess(response.Data));
    } else {
      yield put(getPSMSPACaseSubmissionFailure('No data returned'));
    }
  } catch (error: any) {
    yield put(getPSMSPACaseSubmissionFailure(error?.message || 'Failed to fetch data'));
  } finally {
    yield put(getPSMSPACaseSubmissionLoading(false));
  }
}

export function* fetchPSMSPACaseSubmissionChannelData(action: any) {
  const payload = action?.payload || {};
  yield put(getPSMSPACaseSubmissionChannelLoading(true));
  try {
    const response = yield call(getPSMSPACaseSubmissionChannelData, payload);
    if (response?.Data) {
      yield put(getPSMSPACaseSubmissionChannelSuccess(response.Data));
    } else {
      yield put(getPSMSPACaseSubmissionChannelFailure('No data returned'));
    }
  } catch (error: any) {
    yield put(getPSMSPACaseSubmissionChannelFailure(error?.message || 'Failed to fetch data'));
  } finally {
    yield put(getPSMSPACaseSubmissionChannelLoading(false));
  }
}

export function* fetchPSMSPAApprovalDenialTrendData(action: any) {
  const payload = action?.payload || {};
  yield put(getPSMSPAApprovalDenialTrendLoading(true));
  try {
    const response = yield call(getPSMSPAApprovalDenialTrendData, payload);
    if (response?.Data) {
      yield put(getPSMSPAApprovalDenialTrendSuccess(response.Data));
    } else {
      yield put(getPSMSPAApprovalDenialTrendFailure('No data returned'));
    }
  } catch (error: any) {
    yield put(getPSMSPAApprovalDenialTrendFailure(error?.message || 'Failed to fetch data'));
  } finally {
    yield put(getPSMSPAApprovalDenialTrendLoading(false));
  }
}

export function* fetchPSMSPATatTrendData(action: any) {
  const payload = action?.payload || {};
  yield put(getPSMSPATatTrendLoading(true));
  try {
    const response = yield call(getPSMSPATatTrendData, payload);
    if (response?.Data) {
      yield put(getPSMSPATatTrendSuccess(response.Data));
    } else {
      yield put(getPSMSPATatTrendFailure('No data returned'));
    }
  } catch (error: any) {
    yield put(getPSMSPATatTrendFailure(error?.message || 'Failed to fetch data'));
  } finally {
    yield put(getPSMSPATatTrendLoading(false));
  }
}

function* priorAuthSaga() {
  yield takeLatest(PSMS_PA_CASE_SUBMISSION_REQUEST, fetchPSMSPACaseSubmissionData);
  yield takeLatest(PSMS_PA_CASE_SUBMISSION_CHANNEL_REQUEST, fetchPSMSPACaseSubmissionChannelData);
  yield takeLatest(PSMS_PA_APPROVAL_DENIAL_TREND_REQUEST, fetchPSMSPAApprovalDenialTrendData);
  yield takeLatest(PSMS_PA_TAT_TREND_REQUEST, fetchPSMSPATatTrendData);
}

export default priorAuthSaga;
